function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4299380e\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../vue-loader/lib/selector?type=styles&index=0!./Expanding.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Expanding.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4299380e\",\"hasScoped\":true}!../../vue-loader/lib/selector?type=template&index=0!./Expanding.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4299380e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-expanding/src/Expanding.vue
// module id = 52
// module chunks = 4